import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';

import * as actions from '../actions/document';

const initialState = fromJS({
  codes: {
    status: { data: [], state: null },
  },
  documents: { data: [], state: null },
  document: { data: {}, state: null },
  files: { data: [], state: null },
  file: { data: {}, state: null },
});

const documentReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_CODEFILE_DOCUMENT_STATUS_START: {
      return state.setIn(['codes', 'status', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CODEFILE_DOCUMENT_STATUS_SUCCESS: {
      return state
        .setIn(['codes', 'status', 'state'], fetchingState.LOADED)
        .setIn(
          ['codes', 'status', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_DOCUMENTS_START: {
      return state.setIn(['documents', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_DOCUMENT_START: {
      return state.setIn(['document', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_DOCUMENT_START: {
      return state.setIn(['document', 'state'], fetchingState.FETCHING);
    }
    case actions.UPDATE_DOCUMENT_TAGS_START:
    case actions.UPDATE_DOCUMENT_START: {
      return state.setIn(['document', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_DOCUMENT_START: {
      return state.setIn(['document', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_DOCUMENT_FILES_START: {
      return state
        .setIn(['files', 'state'], fetchingState.FETCHING)
        .setIn(['files', 'data'], fromJS([]));
    }
    case actions.FETCH_DOCUMENT_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_DOCUMENT_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_DOCUMENT_FILE_START: {
      return state.setIn(['file', 'state'], fetchingState.FETCHING);
    }

    case actions.FETCH_DOCUMENTS_SUCCESS: {
      return state
        .setIn(['documents', 'state'], fetchingState.LOADED)
        .setIn(
          ['documents', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_DOCUMENT_SUCCESS: {
      return state
        .setIn(['document', 'state'], fetchingState.LOADED)
        .setIn(
          ['document', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.INSERT_DOCUMENT_SUCCESS: {
      return state
        .setIn(['document', 'state'], fetchingState.LOADED)
        .setIn(
          ['document', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.UPDATE_DOCUMENT_SUCCESS: {
      return state.setIn(['document', 'state'], fetchingState.LOADED);
    }
    case actions.UPDATE_DOCUMENT_TAGS_SUCCESS: {
      return state.setIn(
        ['document', 'data'],
        fromJS({
          ...state.getIn(['document', 'data']),
          tags: _.get(action, 'data.resutls', []),
        }),
      );
    }

    case actions.DELETE_DOCUMENT_SUCCESS: {
      return state.setIn(['document', 'state'], fetchingState.LOADED);
    }
    case actions.FETCH_DOCUMENT_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_DOCUMENT_FILE_SUCCESS: {
      return state
        .setIn(['file', 'state'], fetchingState.LOADED)
        .setIn(['file', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_DOCUMENT_FILE_SUCCESS: {
      return state.setIn(['file', 'state'], fetchingState.LOADED);
    }
    case actions.DELETE_DOCUMENT_FILE_SUCCESS: {
      return state.setIn(['file', 'state'], fetchingState.LOADED);
    }

    case actions.FETCH_DOCUMENTS_ERROR: {
      return state.setIn(['documents', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_DOCUMENT_ERROR: {
      return state.setIn(['document', 'state'], fetchingState.ERROR);
    }
    case actions.INSERT_DOCUMENT_ERROR: {
      return state.setIn(['document', 'state'], fetchingState.ERROR);
    }
    case actions.UPDATE_DOCUMENT_ERROR: {
      return state.setIn(['document', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_DOCUMENT_ERROR: {
      return state.setIn(['document', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_DOCUMENT_FILES_ERROR: {
      return state.setIn(['files', 'state'], fetchingState.ERROR);
    }
    case actions.FETCH_DOCUMENT_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.INSERT_DOCUMENT_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }
    case actions.DELETE_DOCUMENT_FILE_ERROR: {
      return state.setIn(['file', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};

export default documentReducer;
